<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="getName"
    :vid="vid"
    :rules="getRules"
  >
    <div
      :class="{
        'form-group--error': errors.length,
        'form-group--required': isRequired
      }"
      class="form-group"
    >
      <label
        :for="name"
        class="form-label"
      >{{ hasLabel ? label : getName }}</label>
      <input
        :id="name"
        v-model="model"
        :name="name"
        :readonly="readonly"
        :disabled="disabled"
        type="password"
        class="form-input u-br"
      >
      <span class="form-helptext">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import FormMixin from '@components/forms/FormMixin'

export default {
  mixins: [FormMixin],
}
</script>

